<template>
  <vue-perfect-scrollbar class="scroll-area">
    <vs-tabs
      :position="isSmallerScreen ? 'top' : 'left'"
      class="tabs-shadow-none"
      id="profile-tabs"
      :key="isSmallerScreen"
    >
      <vs-tab label="Automated Reports" icon-pack="feather" icon="icon-file">
        <UserSettingsReports></UserSettingsReports>
      </vs-tab>
      <vs-tab label="Event Subscriptions" icon-pack="feather" icon="icon-bell">
        <UserSettingsEvents></UserSettingsEvents>
      </vs-tab>
      <vs-tab label="3rd Party Data Push" icon-pack="feather" icon="icon-radio">
        <UserSettingsDataPush />
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-user" label="Account">
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <user-settings-general />
        </div>
      </vs-tab>
      <vs-tab label="POI/Geofence" icon-pack="feather" icon="icon-home">
        <POI></POI>
      </vs-tab>

      <vs-tab label="Users" icon-pack="feather" icon="icon-user">
        <UserManagement></UserManagement>
      </vs-tab>
      <vs-tab label="Units" icon-pack="feather" icon="icon-truck">
        <UnitManagement></UnitManagement>
      </vs-tab>
      <vs-tab
        label="Vendor Certificate"
        icon-pack="feather"
        icon="icon-copy"
        class="flex h-full overflow-hidden"
      >
        <PrintCertificate></PrintCertificate>
      </vs-tab>
    </vs-tabs>
  </vue-perfect-scrollbar>
</template>

<script>
import UserSettingsReports from './UserSettingsReports.vue';
import UnitManagement from './UnitManagement.vue';
import UserSettingsEvents from './UserSettingsEvents.vue';
import UserManagement from './UserManagement.vue';
import UserSettingsGeneral from './UserSettingsGeneral.vue';
import UserSettingsChangePassword from './UserSettingsChangePassword.vue';
import PrintCertificate from './PrintCertificate.vue';
import POI from './POI.vue';
import UserSettingsDataPush from './UserSettingsDataPush.vue';

export default {
  components: {
    POI,
    UserSettingsGeneral,
    PrintCertificate,
    UserSettingsChangePassword,
    UserManagement,
    UserSettingsEvents,
    UnitManagement,
    UserSettingsReports,
    UserSettingsDataPush,
  },
  data() {
    return {};
  },
  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },
  },
};
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
